module.exports = __webpack_public_path__ + "media/images/procedure_managements/desktop_preview-4fc65214a7c7c36a14d40548036f9fd9.png";